export const getShrunkText = (text, length = 10) => {
    if (text.length > length) {
        return text.substring(0, length) + "...";
    }
    return text;
}